import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";
 // Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/user.png";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import UserUpdate from "./userUpdate";


const UserProfile = () => {

  //meta title
  document.title = "Profile | Care-Tip - React Admin & Dashboard";

  const dispatch = useDispatch();

  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  const [lastLoginAt, setlastloginAt] = useState("");
  const [picture, setpicture] = useState("");

  const selectProfileState = (state) => state.Profile;
    const ProfileProperties = createSelector(
      selectProfileState,
        (profile) => ({
          error: profile.error,
          success: profile.success,
        })
    );

    const {
      error,
      success
  } = useSelector(ProfileProperties);

  function formatDate(timestamp) {
    const date = new Date(Number(timestamp))
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }
    let formattedDate = date.toLocaleString("en-GB", options)

    // Find the day number to append the correct ordinal indicator
    const day = date.getDate()
    let ordinalIndicator
    if (day > 3 && day < 21) ordinalIndicator = "th"
    else if (day % 10 === 1) ordinalIndicator = "st"
    else if (day % 10 === 2) ordinalIndicator = "nd"
    else if (day % 10 === 3) ordinalIndicator = "rd"
    else ordinalIndicator = "th"

    // Replace the day number with day number + ordinal indicator in the formatted string
    formattedDate = formattedDate.replace(
      new RegExp(` ${day} `),
      ` ${day}${ordinalIndicator} `
    )

    // Add 'at' before the time
    formattedDate = formattedDate.replace(",", " at")

    return formattedDate
  }

  //console.log(formatDate(lastLoginAt))


  useEffect(() => {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      
      // console.log(obj);

      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setname(obj.displayName);
        setemail(obj.email);
        setidx(obj.uid);
        setpicture(obj.photoURL);
        setlastloginAt(formatDate(obj.lastLoginAt))
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setname(obj.username);
        setemail(obj.email);
        setidx(obj.uid);
      }
      setTimeout(() => {
        dispatch(resetProfileFlag());
      }, 3000);
    }
  }, [dispatch, success]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || '',
      idx: idx || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please enter your username"),
    }),
    onSubmit: (values) => {
     
      dispatch(editProfile(values));
    }
  });


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Care-Tip" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      {/* <img
                        src={ picture ? picture : avatar }
                        alt={ name }
                        className="avatar-md rounded-circle img-thumbnail"
                      /> */}
                      <img
                        src={picture ? picture : avatar}
                        alt={name}
                        className="avatar-md rounded-circle img-thumbnail"
                        style={{
                          objectFit: "cover",
                          width: "auto",
                        }}
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">Last login: {lastLoginAt}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Profile Update</h4>
         
          <UserUpdate />

          {/* <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-group">
                  <Label className="form-label">User Name</Label>
                  <Input
                    name="username"
                    // value={name}
                    className="form-control"
                    placeholder="Enter User Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.username || ""}
                    invalid={
                      validation.touched.username && validation.errors.username ? true : false
                    }
                  />
                  {validation.touched.username && validation.errors.username ? (
                    <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                  ) : null}
                  <Input name="idx" value={idx} type="hidden" />
                </div>
                <div className="text-center mt-4">
                  <Button type="submit" color="danger">
                    Update User Name
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card> */}
        </Container>
      </div>
    </React.Fragment>
  )
};

export default withRouter(UserProfile);
